export default (bottle) => {
  bottle.factory('setTimeout', () => setTimeout);

  bottle.factory('sleep', ({ setTimeout }) => time => new Promise(resolve => setTimeout(() => resolve(), time)));

  bottle.factory('localStorage', ({ window }) => (window ? window.localStorage : null));

  bottle.factory('session', ({ getSession, clearSession, setSession }) => ({
    set: setSession,
    get: getSession,
    clear: clearSession,
  }));

  bottle.factory('getSession', ({ localStorage }) => function getSession() {
    if (!localStorage) return null;
    const exp = localStorage.getItem('ephemeralExp');
    const bearerToken = localStorage.getItem('ephemeralBearerToken');

    return {
      exp, bearerToken,
    };
  });

  bottle.factory('clearSession', ({ localStorage }) => function clearSession() {
    if (!localStorage) return;
    localStorage.removeItem('ephemeral-exp');
    localStorage.removeItem('ephemeral-bearerToken');
  });

  bottle.factory('setSession', ({ localStorage, clearSession }) => function setSession(params) {
    if (!localStorage) return undefined;
    if (!(params && (typeof params === 'object'))) {
      console.log('bad session:', params);
      return clearSession();
    }
    const { exp, bearerToken } = params;

    localStorage.setItem('ephemeralExp', exp);
    localStorage.setItem('ephemeralBearerToken', bearerToken);

    return params;
  });
};
